module.exports = __webpack_public_path__ + "static/media/org-dashboard.656431e6.svg";